/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type IFollowOfferingMutationVariables = Types.Exact<{
  input: Types.IFollowCreateInput;
}>;

export type IFollowOfferingMutation = {
  __typename?: 'Mutation';
  follow?:
    | {
        __typename?: 'FollowCreatePayload';
        target?:
          | { __typename?: 'Offering'; following: boolean }
          | { __typename?: 'TagsTag' }
          | { __typename?: 'User' }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IFundedOfferingsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  searchParams: Types.IOfferingSearchInput;
}>;

export type IFundedOfferingsQuery = {
  __typename?: 'Query';
  offeringsSearch: {
    __typename?: 'OfferingConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null | undefined;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Offering';
      id: string;
      slug: string;
      companyName: string;
      description?: string | null | undefined;
      following: boolean;
      hostingEntityForDisplay?: string | null | undefined;
      regulationForDisplay: string;
      logoUrl?: string | null | undefined;
      cardImageUrl?: string | null | undefined;
      badgeList: Array<{
        __typename?: 'OfferingBadge';
        label: string;
        name: Types.IOfferingAvailableBadgeNameEnum;
      }>;
    }>;
  };
};

export type IGrowthStageOfferingsQueryVariables = Types.Exact<{
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  searchParams: Types.IOfferingSearchInput;
}>;

export type IGrowthStageOfferingsQuery = {
  __typename?: 'Query';
  offeringsSearch: {
    __typename?: 'OfferingConnection';
    totalCount: number;
    pageInfo: {
      __typename?: 'PageInfo';
      endCursor?: string | null | undefined;
      hasNextPage: boolean;
    };
    nodes: Array<{
      __typename?: 'Offering';
      id: string;
      slug: string;
      companyName: string;
      description?: string | null | undefined;
      following: boolean;
      hostingEntityForDisplay?: string | null | undefined;
      regulationForDisplay: string;
      logoUrl?: string | null | undefined;
      cardImageUrl?: string | null | undefined;
      badgeList: Array<{
        __typename?: 'OfferingBadge';
        label: string;
        name: Types.IOfferingAvailableBadgeNameEnum;
      }>;
    }>;
  };
};

export type IUnfollowOfferingMutationVariables = Types.Exact<{
  input: Types.IFollowDeleteInput;
}>;

export type IUnfollowOfferingMutation = {
  __typename?: 'Mutation';
  unfollow?:
    | {
        __typename?: 'FollowDeletePayload';
        target?:
          | { __typename?: 'Offering'; following: boolean }
          | { __typename?: 'TagsTag' }
          | { __typename?: 'User' }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export const FollowOfferingDocument = gql`
  mutation FollowOffering($input: FollowCreateInput!) {
    follow(input: $input) {
      target {
        ... on Offering {
          following
        }
      }
      errors {
        message
      }
    }
  }
`;
export type IFollowOfferingMutationFn = Apollo.MutationFunction<
  IFollowOfferingMutation,
  IFollowOfferingMutationVariables
>;
export type FollowOfferingMutationResult =
  Apollo.MutationResult<IFollowOfferingMutation>;
export type FollowOfferingMutationOptions = Apollo.BaseMutationOptions<
  IFollowOfferingMutation,
  IFollowOfferingMutationVariables
>;
export const FundedOfferingsDocument = gql`
  query FundedOfferings(
    $first: Int
    $after: String
    $searchParams: OfferingSearchInput!
  ) {
    offeringsSearch(first: $first, after: $after, searchParams: $searchParams) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        slug
        badgeList {
          label
          name
        }
        companyName
        description
        following
        hostingEntityForDisplay
        regulationForDisplay
        logoUrl(extension: webp, resize: { width: 96, height: 96, type: fit })
        cardImageUrl(
          extension: webp
          resize: { width: 700, height: 400, type: fill }
        )
      }
    }
  }
`;
export type FundedOfferingsQueryResult = Apollo.QueryResult<
  IFundedOfferingsQuery,
  IFundedOfferingsQueryVariables
>;
export const GrowthStageOfferingsDocument = gql`
  query GrowthStageOfferings($first: Int, $searchParams: OfferingSearchInput!) {
    offeringsSearch(first: $first, searchParams: $searchParams) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      nodes {
        id
        slug
        badgeList {
          label
          name
        }
        companyName
        description
        following
        hostingEntityForDisplay
        regulationForDisplay
        logoUrl(extension: webp, resize: { width: 96, height: 96, type: fit })
        cardImageUrl(
          extension: webp
          resize: { width: 1090, height: 614, type: fill }
        )
      }
    }
  }
`;
export type GrowthStageOfferingsQueryResult = Apollo.QueryResult<
  IGrowthStageOfferingsQuery,
  IGrowthStageOfferingsQueryVariables
>;
export const UnfollowOfferingDocument = gql`
  mutation UnfollowOffering($input: FollowDeleteInput!) {
    unfollow(input: $input) {
      target {
        ... on Offering {
          following
        }
      }
      errors {
        message
      }
    }
  }
`;
export type IUnfollowOfferingMutationFn = Apollo.MutationFunction<
  IUnfollowOfferingMutation,
  IUnfollowOfferingMutationVariables
>;
export type UnfollowOfferingMutationResult =
  Apollo.MutationResult<IUnfollowOfferingMutation>;
export type UnfollowOfferingMutationOptions = Apollo.BaseMutationOptions<
  IUnfollowOfferingMutation,
  IUnfollowOfferingMutationVariables
>;
